import { useCallback } from "react";

import useTypedContext from "hooks/useTypedContext";
import { Plugin } from "types/generated";
import { AccessResult, NO_ACCESS_MESSAGE } from "utils/access";
import { hasSpaceManageAccess } from "utils/user";
import { AccountContext } from "views/AccountWrapper";

const useCanDeleteInstalledPlugins = (): ((plugin: Plugin) => AccessResult) => {
  const { viewer } = useTypedContext(AccountContext);

  return useCallback(
    (plugin) => {
      if (viewer.admin) {
        return { result: true };
      }

      // TODO: [AAC] check why accessLevel is still used here
      if (hasSpaceManageAccess(plugin.spaceDetails?.accessLevel)) {
        return { result: true };
      }

      return { result: false, message: NO_ACCESS_MESSAGE };
    },
    [viewer]
  );
};

export default useCanDeleteInstalledPlugins;
